"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ContactForm = _interopRequireDefault(require("../../organisms/ContactForm"));

var Subscribe = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Subscribe, _React$Component);

  function Subscribe() {
    (0, _classCallCheck2["default"])(this, Subscribe);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Subscribe).apply(this, arguments));
  }

  (0, _createClass2["default"])(Subscribe, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fluidButton = _this$props.fluidButton,
          placeholder = _this$props.placeholder,
          header = _this$props.header,
          subheader = _this$props.subheader,
          onSubmit = _this$props.onSubmit,
          centered = _this$props.centered;
      return _react["default"].createElement(_ContactForm["default"], {
        onSubmit: onSubmit,
        fluidButton: fluidButton,
        centeredHeaders: centered,
        fields: [{
          label: 'email',
          placeholder: placeholder,
          type: 'input'
        }],
        header: header,
        subheader: subheader,
        buttonText: "Subscribe"
      });
    }
  }]);
  return Subscribe;
}(_react["default"].Component);

exports["default"] = Subscribe;
Subscribe.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  centered: _propTypes["default"].bool,
  fluidButton: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  subheader: _propTypes["default"].string
};
Subscribe.defaultProps = {
  centered: false,
  fluidButton: false,
  header: '',
  placeholder: 'youremail@provider.com',
  subheader: ''
};
Subscribe.propOptions = {
  header: ['Subscribe', '']
};